import { render, staticRenderFns } from "./OzDrawerDraggable.vue?vue&type=template&id=55a77d10&scoped=true&"
import script from "./OzDrawerDraggable.vue?vue&type=script&setup=true&lang=ts&"
export * from "./OzDrawerDraggable.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./OzDrawerDraggable.vue?vue&type=style&index=0&id=55a77d10&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a77d10",
  null
  
)

export default component.exports